import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/FileInput/FileInput.js",
    _this = this;
/* eslint-disable flowtype/no-types-missing-file-annotation */


import React, { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import PlusIcon from '@dls/assets/icons/Plus';
import { space } from '@styled-system/space';
import FileListItem, { FileType, ListItemWrapper, ListType, FileUploadStatus } from './FileListItem';
import IconButton, { ActionTextWrapper } from './IconButton';
import IconTrashButton from './IconTrashButton';
import { withTheme } from '../../core/ThemeProvider';
import Text from '../Text';
import { testIdProps } from '../../helpers';
import { responsiveStyles } from '../../core/utils/responsiveStyles';

var FileInput = function FileInput(_ref) {
  var id = _ref.id,
      label = _ref.label,
      children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    id: id,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 24,
      columnNumber: 5
    }
  }, label && /*#__PURE__*/React.createElement(LabelText, {
    type: "smallBody",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 25,
      columnNumber: 17
    }
  }, label), children);
};

FileInput.defaultProps = {};
var singleFileUploadInitialState = {
  file: null,
  fileType: null,
  fileLoadedStatus: false,
  fileLoadedError: false
};

var DropZone = function DropZone(props) {
  var fileInputRef = /*#__PURE__*/React.createRef();

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isDragActive = _useState2[0],
      setDragActive = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isFileDoneLoading = _useState4[0],
      setFileDoneLoading = _useState4[1]; // single file upload mode states for file, file type and upload status


  var _useState5 = useState(singleFileUploadInitialState),
      _useState6 = _slicedToArray(_useState5, 2),
      loadedFile = _useState6[0],
      setLoadedFile = _useState6[1];

  var removeLoadedFile = function removeLoadedFile() {
    setLoadedFile(singleFileUploadInitialState);
    singleModeOnDelete();
  };

  var triggerFileInput = function triggerFileInput() {
    !props.disabled && fileInputRef && fileInputRef.current && fileInputRef.current.click();
    setDragActive(false);
  };

  var onLoadFiles = function onLoadFiles(files) {
    if (!files || !files.length) return;
    var onDrop = props.onDrop;
    var loadedCount = 0;

    _toConsumableArray(files).forEach(function (file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);

      reader.onload = function () {
        loadedCount++;
        file.src = reader.result;

        if (isSingleUploadMode) {
          setFileDoneLoading(true);
          setLoadedFile(function (prevLoadedState) {
            return Object.assign({}, prevLoadedState, {
              file: file,
              fileType: file === null || file === void 0 ? void 0 : file.type.split('/').shift(),
              fileLoadedStatus: false,
              fileLoadedError: false
            });
          });
          onDrop && onDrop([file]);
        } else if (loadedCount === files.length) {
          var fileListArr = Array.prototype.map.apply(files, [function (file) {
            return file;
          }]);
          onDrop && onDrop(fileListArr);
          setFileDoneLoading(true);
        }
      };
    });
  };

  var handleFileChange = function handleFileChange(e) {
    setFileDoneLoading(false);
    var fileList = e.target.files || [];
    onLoadFiles(fileList);
  };

  var onDragOver = function onDragOver(e) {
    e.preventDefault();
    var disabled = props.disabled;
    /* Enable drag effect
     * https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/dropEffect */

    e.dataTransfer && (e.dataTransfer.dropEffect = disabled ? 'none' : 'copy');
    if (props.disabled) return;
    setDragActive(true);
  };

  var onDragLeave = function onDragLeave(e) {
    e.preventDefault();
    if (props.disabled) return;
    setDragActive(false);
  };

  var onDrop = function onDrop(e) {
    e.preventDefault();
    if (props.disabled) return;
    setFileDoneLoading(false);
    setDragActive(false);
    /** Ref: https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/files */

    var _e$dataTransfer = e.dataTransfer;
    _e$dataTransfer = _e$dataTransfer === void 0 ? {} : _e$dataTransfer;
    var _e$dataTransfer$files = _e$dataTransfer.files,
        files = _e$dataTransfer$files === void 0 ? [] : _e$dataTransfer$files;
    onLoadFiles(files);
  };

  var disabled = props.disabled,
      labelText = props.labelText,
      hintText = props.hintText,
      coreTheme = props.coreTheme,
      _props$inputProps = props.inputProps;
  _props$inputProps = _props$inputProps === void 0 ? {} : _props$inputProps;
  var accept = _props$inputProps.accept,
      multiple = _props$inputProps.multiple,
      isError = props.isError,
      errorMessage = props.errorMessage,
      isSingleUploadMode = props.isSingleUploadMode,
      singleUploadStatus = props.singleUploadStatus,
      _props$singleModeOnDe = props.singleModeOnDelete,
      singleModeOnDelete = _props$singleModeOnDe === void 0 ? function () {} : _props$singleModeOnDe,
      singleModePreloadedFile = props.singleModePreloadedFile;
  useEffect(function () {
    if (singleModePreloadedFile) {
      setLoadedFile(function (prevLoadedState) {
        return Object.assign({}, prevLoadedState, {
          file: singleModePreloadedFile,
          fileType: singleModePreloadedFile === null || singleModePreloadedFile === void 0 ? void 0 : singleModePreloadedFile.type.split('/').shift(),
          fileLoadedStatus: false,
          fileLoadedError: false
        });
      });
    }
  }, [singleModePreloadedFile]);

  var isErrorState = function isErrorState() {
    return isError === true && isFileDoneLoading;
  };

  var isFileTypeImage = function isFileTypeImage(file, fileType) {
    return file && fileType && fileType === FileType.IMAGE;
  };

  var renderSingleModeContent = function renderSingleModeContent() {
    var file = loadedFile.file,
        fileType = loadedFile.fileType; // TODO: to get listType as prop and handle for single file upload mode

    var fileInputProps = {
      fileType: fileType,
      listType: fileType === FileType.IMAGE ? ListType.PICTURE : ListType.TEXT,
      imageSrc: file === null || file === void 0 ? void 0 : file.src,
      isFullWidth: fileType === FileType.IMAGE,
      status: singleUploadStatus,
      error: isErrorState(),
      animate: !singleModePreloadedFile
    };

    if (!file || isErrorState()) {
      return /*#__PURE__*/React.createElement(SingleModeWrapper, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(SingleModeContent, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 179,
          columnNumber: 11
        }
      }, renderDropZone()));
    }

    if (isFileTypeImage(file, fileType)) {
      return /*#__PURE__*/React.createElement(SingleModeWrapper, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 186,
          columnNumber: 9
        }
      }, /*#__PURE__*/React.createElement(StyledSingleModeContent, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 187,
          columnNumber: 11
        }
      }, /*#__PURE__*/React.createElement(FileInput.FileListItem, _extends({}, fileInputProps, {
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188,
          columnNumber: 13
        }
      }))));
    } else {
      return /*#__PURE__*/React.createElement(FileInput.FileListItem, _extends({}, fileInputProps, {
        action: /*#__PURE__*/React.createElement(IconTrashButton, {
          onClick: removeLoadedFile,
          __self: _this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 196,
            columnNumber: 19
          }
        }),
        __self: _this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 194,
          columnNumber: 9
        }
      }), file.name);
    }
  };

  var renderSingleUploadMode = function renderSingleUploadMode() {
    var file = loadedFile.file,
        fileType = loadedFile.fileType;
    return /*#__PURE__*/React.createElement(SingleModeContentWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 208,
        columnNumber: 7
      }
    }, isFileTypeImage(file, fileType) && singleUploadStatus === FileUploadStatus.SUCCESS && !isErrorState() && /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: removeLoadedFile,
      enableInteraction: true,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 212,
        columnNumber: 13
      }
    }, "Delete"), renderSingleModeContent());
  };

  var renderDropZone = function renderDropZone() {
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(DropZoneContainer, _extends({}, testIdProps(props, 'dropZone'), {
      disabled: disabled,
      onClick: triggerFileInput,
      onDragOver: onDragOver,
      onDragLeave: onDragLeave,
      onDrop: onDrop,
      isDragActive: isDragActive,
      isError: isErrorState(),
      isSingleUploadMode: isSingleUploadMode,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 225,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement("input", {
      "data-testid": "fileInputEl",
      ref: fileInputRef,
      type: "file",
      accept: accept,
      multiple: !!multiple && !isSingleUploadMode,
      onChange: handleFileChange
      /** reset the value onClick, triggering onChange to allow uploading same file */
      ,
      onClick: function onClick(e) {
        return e.target.value = null;
      },
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 236,
        columnNumber: 11
      }
    }), labelText && /*#__PURE__*/React.createElement(Flex, {
      m: "8px",
      alignItems: "center",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 248,
        columnNumber: 13
      }
    }, /*#__PURE__*/React.createElement(PlusIcon, {
      size: 21,
      color: coreTheme.cl_sec_d1,
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 249,
        columnNumber: 15
      }
    }), /*#__PURE__*/React.createElement(DropZoneText, {
      type: "link",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 250,
        columnNumber: 15
      }
    }, labelText)), hintText && /*#__PURE__*/React.createElement(HintText, {
      type: "smallBody",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 254,
        columnNumber: 24
      }
    }, hintText)), isErrorState() && /*#__PURE__*/React.createElement(ErrorText, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 256,
        columnNumber: 28
      }
    }, errorMessage));
  };

  if (isSingleUploadMode) {
    return renderSingleUploadMode();
  }

  return renderDropZone();
};

DropZone.defaultProps = {
  inputProps: {
    multiple: false
  }
};
FileInput.FileListItem = FileListItem;
FileInput.ListItemWrapper = ListItemWrapper;
FileInput.IconButton = IconButton;
FileInput.IconTrashButton = IconTrashButton;
FileInput.DropZone = withTheme(DropZone);
var DropZoneContainer = withTheme(styled.div.withConfig({
  displayName: "FileInput__DropZoneContainer",
  componentId: "sc-krfcbk-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;", ";&:active{border-style:solid;}input[type='file']{display:none !important;visibility:hidden;}"], function (_ref2) {
  var coreTheme = _ref2.coreTheme,
      isDragActive = _ref2.isDragActive,
      isError = _ref2.isError,
      isSingleUploadMode = _ref2.isSingleUploadMode;
  return css(["height:", ";padding:", ";text-align:center;box-sizing:border-box;border:1px ", ";border-radius:", ";margin-top:", ";min-height:200px;"], isSingleUploadMode ? "calc(100% - 2px)" : 0, isSingleUploadMode ? 0 : "".concat(coreTheme.space_4, "px"), isDragActive || isError ? "solid ".concat(isError ? coreTheme.cl_pri_d3 : coreTheme.cl_sec_d1) : "dashed ".concat(coreTheme.cl_sec_d1), coreTheme.rad_xs, isSingleUploadMode ? 0 : "".concat(coreTheme.space_2, "px"));
}));
/* TODO: Consider moving this to a shared utility component */

var Flex = styled.div.withConfig({
  displayName: "FileInput__Flex",
  componentId: "sc-krfcbk-1"
})(["display:flex;", " ", ""], function (_ref3) {
  var _ref3$alignItems = _ref3.alignItems,
      alignItems = _ref3$alignItems === void 0 ? 'start' : _ref3$alignItems;
  return css(["align-items:", ";"], alignItems);
}, space);
var DropZoneText = withTheme(styled(Text).withConfig({
  displayName: "FileInput__DropZoneText",
  componentId: "sc-krfcbk-2"
})(function (_ref4) {
  var _coreTheme$fileInput, _coreTheme$fileInput2;

  var coreTheme = _ref4.coreTheme;
  return css(["line-height:28px;color:", ";", ";margin-left:", "px;"], coreTheme.cl_sec_d1, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$fileInput = coreTheme.fileInput) !== null && _coreTheme$fileInput !== void 0 && _coreTheme$fileInput.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput2 = coreTheme.fileInput) === null || _coreTheme$fileInput2 === void 0 ? void 0 : _coreTheme$fileInput2.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_xl
  }, coreTheme.space_2);
}));
var LabelText = withTheme(styled(Text).withConfig({
  displayName: "FileInput__LabelText",
  componentId: "sc-krfcbk-3"
})(function (_ref5) {
  var _coreTheme$fileInput3, _coreTheme$fileInput4, _coreTheme$fileInput5, _coreTheme$fileInput6;

  var coreTheme = _ref5.coreTheme;
  return css(["line-height:21px;color:", ";", ";", ";display:flex;margin-bottom:", "px;"], coreTheme.cl_ter_l2, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$fileInput3 = coreTheme.fileInput) !== null && _coreTheme$fileInput3 !== void 0 && _coreTheme$fileInput3.fontSizeLabelText ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput4 = coreTheme.fileInput) === null || _coreTheme$fileInput4 === void 0 ? void 0 : _coreTheme$fileInput4.fontSizeLabelText
  }, coreTheme)) : {
    fontSize: coreTheme.fs_sm
  }, (coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput5 = coreTheme.fileInput) === null || _coreTheme$fileInput5 === void 0 ? void 0 : _coreTheme$fileInput5.fontWeightLabelText) && {
    fontWeight: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput6 = coreTheme.fileInput) === null || _coreTheme$fileInput6 === void 0 ? void 0 : _coreTheme$fileInput6.fontWeightLabelText
  }, coreTheme.space_2);
}));
var HintText = withTheme(styled(Text).withConfig({
  displayName: "FileInput__HintText",
  componentId: "sc-krfcbk-4"
})(["", ";"], function (_ref6) {
  var _coreTheme$fileInput7, _coreTheme$fileInput8;

  var coreTheme = _ref6.coreTheme;
  return css(["color:", ";line-height:21px;", ";"], coreTheme.cl_ter_l2, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$fileInput7 = coreTheme.fileInput) !== null && _coreTheme$fileInput7 !== void 0 && _coreTheme$fileInput7.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput8 = coreTheme.fileInput) === null || _coreTheme$fileInput8 === void 0 ? void 0 : _coreTheme$fileInput8.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_md
  });
}));
var ErrorText = withTheme(styled(Text).withConfig({
  displayName: "FileInput__ErrorText",
  componentId: "sc-krfcbk-5"
})(["", ";"], function (_ref7) {
  var _coreTheme$fileInput9, _coreTheme$fileInput10;

  var coreTheme = _ref7.coreTheme;
  return css(["color:", ";", ";margin-top:", "px;"], coreTheme.cl_pri_d3, coreTheme !== null && coreTheme !== void 0 && (_coreTheme$fileInput9 = coreTheme.fileInput) !== null && _coreTheme$fileInput9 !== void 0 && _coreTheme$fileInput9.fontSize ? Object.assign({}, responsiveStyles({
    fontSize: coreTheme === null || coreTheme === void 0 ? void 0 : (_coreTheme$fileInput10 = coreTheme.fileInput) === null || _coreTheme$fileInput10 === void 0 ? void 0 : _coreTheme$fileInput10.fontSize
  }, coreTheme)) : {
    fontSize: coreTheme.fs_md
  }, coreTheme.space_1);
}));
var DeleteButton = withTheme(styled(ActionTextWrapper).withConfig({
  displayName: "FileInput__DeleteButton",
  componentId: "sc-krfcbk-6"
})(["position:absolute;right:0;top:-30px;"]));
var SingleModeWrapper = styled.div.withConfig({
  displayName: "FileInput__SingleModeWrapper",
  componentId: "sc-krfcbk-7"
})(["position:relative;width:100%;overflow:hidden;min-height:200px;height:100%;"]);
var SingleModeContent = styled.div.withConfig({
  displayName: "FileInput__SingleModeContent",
  componentId: "sc-krfcbk-8"
})(["min-height:inherit;"]);
var StyledSingleModeContent = styled(SingleModeContent).withConfig({
  displayName: "FileInput__StyledSingleModeContent",
  componentId: "sc-krfcbk-9"
})(["position:absolute;left:0;right:0;top:0;bottom:0;"]);
var SingleModeContentWrapper = styled.div.withConfig({
  displayName: "FileInput__SingleModeContentWrapper",
  componentId: "sc-krfcbk-10"
})(["position:relative;height:100%;"]);
export default FileInput;